import React, { useContext, Suspense,useState, useEffect } from "react"
import './CustomizePolicy.css'
import FlexView from "react-flexview/lib"
import {  BrowserView, MobileView } from "react-device-detect"
import { Container, Divider, Grid, useMediaQuery } from "@material-ui/core"
import { InsurancePurchaseContextStore } from "../../context/InsuracePurchaseContext"
import { TextDivider } from "../Core/TextDivier"
import { EventEmitterService, EventKey } from "../../services/EventEmitterService"
import { ContinueButton } from "../Core/Buttons/ContinueButton"
import { useLocation } from "react-router-dom"
import { isInFlow, isUK } from "../../services/utils"
import { BottomSheetPolicySummary } from "./BottomSheetPolicySummary"
import { GetAQuotePopup } from "../Quote/GetAQuotePopup"
import ViolationsService from "../../services/ViolationsService"
import { SessionService } from "../../services/SessionService"
import { lazyWithPreload } from "../../utilities/RLazyLoading"
import { FirebaseService, FirebaseConfigKey } from "../../services/FirebaseService"
import { COUNTRIES } from "../../Constants"
import LocalizationService from "../../services/LocalizationService"
import insuranceApi from "../../api/insurance.api"
import { BuyingInsuranceContextStore, FLOW_TYPES } from "../../context/BuyingInsuranceContext"
import { CustomizeOperatorsSection } from "./CustomizePolicySections/CustomizeOperatorsSection"
import { CustomizeCoverageType } from "./CustomizePolicySections/CustomizeCoverageType"
import { CustomizeUASSection } from "./CustomizePolicySections/CustomizeUASSection"
import { CustomizeNumberOfDronesSection } from "./CustomizePolicySections/CustomizeNumberOfDronesSection"
import { CustomizeAdditionalCoverageSection } from "./CustomizePolicySections/CustomizeAdditionalCoverageSection"
import { WhatsCoveredSummarySection } from "./SummarySection/WhatsCoveredSummarySection"
import DataLayerService from "../../services/DataLayerService"
import { CustomizePlanSelection } from './CustomizePolicySections/CustomizePlanSelection'
import BrokerConfigService from "../../services/BrokerConfigService"
import { NUMBER_OF_DRONES_QUESTION_ANSWERS } from "../../Constants";
import { UserProfileContextStore ,ACTIONS} from "../../context/UserProfileContext"
import CustomizeFleetSection from "./CustomizePolicySections/CustomizeFleetSection"
import CustomizeYesNoFleetQuestion from "./CustomizePolicySections/CustomizeYesNoFleetQuestion"
import { BackButton } from "../Core/Buttons/BackButton"


const CustomizeAutoRenew = lazyWithPreload(() => import("./CustomizePolicySections/CustomizeAutoRenew").then(module => ({ default: module.CustomizeAutoRenew })));
const CustomizeAdditionalInsuredSection = lazyWithPreload(() => import( "./CustomizePolicySections/CustomizeAdditionalInsuredSection").then(module => ({ default: module.CustomizeAdditionalInsuredSection })));
const CustomizePolicyStartingDate = lazyWithPreload(() => import("./CustomizePolicySections/CustomizePolicyStartingDate").then(module => ({ default: module.CustomizePolicyStartingDate })));
const CustomizeLiabilitySection = lazyWithPreload(() => import("./CustomizePolicySections/CustomizeLiabilitySection").then(module => ({ default: module.CustomizeLiabilitySection })));
const CustomizeHullSection = lazyWithPreload(() => import("./CustomizePolicySections/CustomizeHullSection").then(module => ({ default: module.CustomizeHullSection })));

export const CustomizePolicyFleet = () => {
    const profileContext = React.useContext(UserProfileContextStore)
    const insurancePurchaseContext = useContext(InsurancePurchaseContextStore)
    const offersContext = useContext(BuyingInsuranceContextStore)
    const location = useLocation()
    const [isAnnualBroker, setIsAnnualBroker] = useState(false);
    const isMobile = !useMediaQuery(theme => theme.breakpoints.up('md'));

    useEffect(() => {
        const isAnnual = async () => {
            const flag = await BrokerConfigService.isAnnualBroker()
            setIsAnnualBroker(flag);
        }
        isAnnual();
        offersContext.setFleetFlow();
    },[])

    const checkNumberOfDronesError = () =>{
        return NUMBER_OF_DRONES_QUESTION_ANSWERS[offersContext.numberOfDronesOperate]['max_drones'] != 0 && insurancePurchaseContext.drones.length > NUMBER_OF_DRONES_QUESTION_ANSWERS[offersContext.numberOfDronesOperate]['max_drones']
    }

    const validateFleetCoverages = () => {
        const {dispatch} = offersContext;
        const {fleetSize, fleetIntendedUse, fleetIsPublishable, fleetProceduresControl} = offersContext?.fleetInformation;
        const data = {
            fleetSize: !fleetSize,
            fleetIntendedUse: !fleetIntendedUse,
            fleetIsPublishable: !fleetIsPublishable,
            fleetProceduresControl: fleetIsPublishable === "true" ? !fleetProceduresControl : false
        }

        dispatch({
            type: 'SET_FLEET_ERRORS',
            data: data
        })

        return Object.keys(data).every(key => !data[key]);
    }

    const onContinue = () => {

        const isValid = validateFleetCoverages();
        if(!isValid) return;
        EventEmitterService.dispatch(EventKey.FLOW_VALIDATE_EVENT)
        let violations = ViolationsService.checkHullViolations(insurancePurchaseContext.selectedOption,
            insurancePurchaseContext.drones, insurancePurchaseContext.equipment)
        if(checkNumberOfDronesError()) return
        if(!ViolationsService.checkOperatorsViolations(offersContext.operators)) return

        if(violations.can_buy_insurance) {
            insurancePurchaseContext.modifyUserAdditionalInsured(insurancePurchaseContext.allAdditionalInsuredList)
            if(SessionService.isLoggedIn())
                insuranceApi.saveQuoteState(insurancePurchaseContext, offersContext)
            DataLayerService.pushToDataLayer({'event': 'continue-at-customize'})
            EventEmitterService.dispatch(EventKey.FLOW_CUSTOMIZE_FINISH)
        }
    }

    return (<React.Fragment>
            
            {isMobile && <TextDivider><div className="text-title bold blue">{LocalizationService.STRINGS.customize} plan</div></TextDivider>}
            
            <Container maxWidth="md">
                <Suspense fallback={<div />}>
                    {!isMobile &&
                        <FlexView className="space-between">
                            <div className="text-title bold blue margin-top-basic main-title">{LocalizationService.STRINGS.customize} {isAnnualBroker ? "Annual" : ""} Policy</div>
                        </FlexView>}
                    {!isMobile &&<Divider />}
                </Suspense>

                <Grid container spacing={2}>
                    { !isAnnualBroker &&
                    <Grid item container sm={12} md={6}>
                        <CustomizePlanSelection />
                        {isMobile && 
                        <Grid item xs={12}>
                            <Divider className="no-margin-bottom"/>
                        </Grid>}
                    </Grid>}

                    <Grid item container sm={12} md={6} justifyContent="space-between" alignItems="center">
                        <CustomizePolicyStartingDate />
                    </Grid>
                </Grid>
                <Divider />

                {FirebaseService.getValue(FirebaseConfigKey.COUNTRY) == COUNTRIES.UK && <>
                    <CustomizeCoverageType />
                    <Divider />
                </>}

                <Suspense fallback={<div />}>
                    <CustomizeLiabilitySection />
                    {/* <Divider /> */}

                    {isUK() && <> 
                        <CustomizeUASSection />
                        <Divider />
                    </>}
                </Suspense>

                <Suspense fallback={<div />}>
                    {/* <CustomizeNumberOfDronesSection /> */}
                    <CustomizeFleetSection/>
                    <Divider />
                </Suspense>

                <Suspense fallback={<div />}>
                    <CustomizeHullSection />
                    <Divider />
    
                  
                </Suspense>
                <CustomizeAdditionalInsuredSection />
                <Divider />
                <CustomizeYesNoFleetQuestion/>
            </Container>
            
            <div>
                <WhatsCoveredSummarySection isFleetPortal={true}/>
                {/* <GuidelinesSummarySection /> */}
            </div>
            
            { !isMobile ? <>
                {/* {isMobile && <BottomSheetPolicySummary  title={'Continue'} onClick={onContinue} />} */}
                {!isMobile && isInFlow(location.pathname) && <FlexView vAlignContent={'center'} className="margin-top-small margin-bottom-basic">
                  <>
                    <BackButton/>
                    <ContinueButton className="margin-right-small" onClick={onContinue} /> 
                    {insurancePurchaseContext.drones.length > 0 && SessionService.isBroker() && <GetAQuotePopup />}
                    </>
                </FlexView>}</>:
                <BottomSheetPolicySummary title={'Continue'} onClick={onContinue} />
            }
            
    </React.Fragment>)
}